import { render } from "./MenuSetting.vue?vue&type=template&id=372c0af8"
import script from "./MenuSetting.vue?vue&type=script&lang=js"
export * from "./MenuSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__